<style lang="scss">
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/colors";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/utils";
  @use "@sourcewhale/shared/svelte-design-system/assets/css/design-system/mixins";

  .manager-controls {
    display: flex;
    flex-direction: column;
    gap: utils.in_rem(16px);

    .call-action-buttons {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(0, 1fr));
      line-height: 1;
      position: relative;
    }

    .end-call-section {
      display: flex;
      gap: 2px;
      justify-content: center;
      margin-top: auto;
      position: relative;
      width: 100%;

      .end-call-button {
        background-color: #ea355e;
        border: none;
        border-radius: 5px;
        color: white;
        cursor: pointer;
        flex: 1;
        font-family: inherit;
        font-size: 0.875rem;
        padding: 0.75rem;

        &:hover {
          background-color: darken(#ea355e, 5%);
        }

        &:active {
          transform: scale(0.98);
        }
      }
    }
  }
</style>

<script>
  import { diallerParticipants } from "@sourcewhale/api";
  import { attendeesState } from "../attendeesState.svelte";
  import { diallerState } from "../diallerState.svelte";
  import { twilioManager } from "../utils/TwilioManager";
  import CallActionButton from "./CallActionButton.svelte";

  const activeCall = $derived(diallerState.activeCall);
  const isMuted = $derived(diallerState.isMuted);
  const managerMode = $derived(attendeesState.manager?.mode);

  const handleModeChange = async (mode) => {
    await diallerParticipants({
      callId: diallerState.callId,
      action: "change-mode",
      mode,
    });
    attendeesState.manager.mode = mode;
  };

  const handleMute = async () => {
    await twilioManager.toggleMute();
  };

  const handleLeaveCall = async () => {
    await diallerState.endCall();
  };
</script>

<div class="manager-controls">
  <div class="call-action-buttons">
    <CallActionButton
      icon={managerMode === "listen" ? "fa-solid fa-ear" : "fa-regular fa-ear"}
      label="Listening"
      active={managerMode === "listen"}
      disabled={!activeCall}
      onclick={() => handleModeChange("listen")}
      testId="manager-listen-button"
    />

    <CallActionButton
      icon={managerMode === "coach"
        ? "fa-solid fa-headphones"
        : "fa-regular fa-headphones"}
      label="Coach"
      active={managerMode === "coach"}
      disabled={!activeCall}
      onclick={() => handleModeChange("coach")}
      testId="manager-coach-button"
    />

    <CallActionButton
      icon={managerMode === "participate"
        ? "fa-solid fa-microphone-stand"
        : "fa-regular fa-microphone-stand"}
      label="Participate"
      active={managerMode === "participate"}
      disabled={!activeCall}
      onclick={() => handleModeChange("participate")}
      testId="manager-participate-button"
    />

    <CallActionButton
      type="mute"
      icon="fa-solid fa-microphone-slash"
      active={isMuted}
      disabled={!activeCall}
      onclick={handleMute}
      testId="manager-mute-button"
    />
  </div>

  <div class="end-call-section">
    <button class="end-call-button" onclick={handleLeaveCall} type="button">
      Leave call
    </button>
  </div>
</div>
